import { render, staticRenderFns } from "./MediaGalleryModal.vue?vue&type=template&id=4380b6ee&"
import script from "./MediaGalleryModal.vue?vue&type=script&lang=js&"
export * from "./MediaGalleryModal.vue?vue&type=script&lang=js&"
import style0 from "./MediaGalleryModal.vue?vue&type=style&index=0&id=4380b6ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports